module.exports = __webpack_public_path__ + "media/features/templates/components/assets/png-background-d1500193d7a2284f07cf772d05670055.png";